import { Checkbox } from "antd";
import ShimmerLoader from "../common/ShimmerLoader";
import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useDispatch } from "react-redux";
import {
  updateDisplayRoomDrawer,
  updateShowMainBookingDetailsDrawer,
} from "../../reducer/bookingReducer";
import { CircularProgress } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  updatePageNo,
  updateShowNightAuditDrawer,
} from "../../reducer/nightAuditReducer";
import { NIGHT_AUDIT_TABLE_HEAD } from "../../utils/nightAuditHelper";
import { getCurrentCurrency } from "../../utils/customCurrencyHelper";
import moment from "moment";

const Body = ({
  loading,
  apiError,
  activeTab,
  infinateScroll,
  data,
  setData,
  allSelected,
  setAllSelected,
  selectedInvoice,
  setSelectedInvoice,
  nightAuditResponse,
  nightAuditLoading,
  hotelDetails,
  summaryRef,
}) => {
  const dispatch = useDispatch();

  const TABLE_HEAD = NIGHT_AUDIT_TABLE_HEAD(activeTab);

  const handleAllSelected = (checked) => {
    const updatedData = data?.map((Obj) => ({
      ...Obj,
      isSelected: checked, // Set all rows' isSelected to match "Select All" state
    }));
    setData(updatedData);
    setAllSelected(checked); // Update "Select All" state

    if (checked) setSelectedInvoice(data);
    else setSelectedInvoice([]);
  };

  const handleSpecificRowCheckBox = (checked, mainIdx) => {
    let givenBooking = data?.find((Obj, idx) => idx === mainIdx);

    if (checked) {
      setSelectedInvoice((prev) => [...prev, givenBooking]);
    } else {
      let updatedData = selectedInvoice?.filter(
        (Obj) => Obj?.id !== givenBooking?.id
      );
      setSelectedInvoice(updatedData);
    }

    const updatedData = data?.map((Obj, idx) =>
      idx === mainIdx ? { ...Obj, isSelected: checked } : Obj
    );

    setData(updatedData);

    // Check if all rows are selected; if yes, update "Select All" state
    const allSelectedState = updatedData.every((item) => item.isSelected);
    setAllSelected(allSelectedState);
  };

  const handleEditBooking = (id) => {
    dispatch(
      updateShowMainBookingDetailsDrawer({
        visible: false,
        bookingId: id,
        bookingType:
          activeTab === 0
            ? "upcoming"
            : activeTab === 1
            ? "ongoing"
            : "completed",
      })
    );

    dispatch(updateShowNightAuditDrawer(true));
    dispatch(updateDisplayRoomDrawer());
  };

  return (
    <div>
      {activeTab === 3 ? (
        nightAuditLoading ? (
          <div className="flex justify-center items-center w-[100vh] h-[60vh]">
            <CircularProgress size={24} />
          </div>
        ) : (
          <SummarySection
            data={nightAuditResponse?.dayReport}
            hotelDetails={hotelDetails}
            summaryRef={summaryRef}
          />
        )
      ) : (
        <Table
          dispatch={dispatch}
          loading={loading}
          apiError={apiError}
          TABLE_HEAD={TABLE_HEAD}
          data={data}
          handleAllSelected={handleAllSelected}
          handleSpecificRowCheckBox={handleSpecificRowCheckBox}
          handleEditBooking={handleEditBooking}
          allSelected={allSelected}
          infinateScroll={infinateScroll}
          activeTab={activeTab}
        />
      )}
    </div>
  );
};

const Table = ({
  dispatch,
  loading,
  apiError,
  TABLE_HEAD,
  data,
  handleAllSelected,
  handleSpecificRowCheckBox,
  handleEditBooking,
  allSelected,
  infinateScroll,
  activeTab,
}) => {
  return (
    <div className="p-3">
      <main
        className={`max-h-[70vh] overflow-y-scroll no-scrollbar 
                 border-[1px] border-brand-border-muted  w-full  rounded-md`}
      >
        <div className=" w-[100%]  text-[0.67rem] text-fg-secondary text-left ">
          <div className=" border-b-[1px] bg-surface-page  border-brand-border-muted sticky top-0 ">
            <div className="flex justify-between items-center">
              {TABLE_HEAD?.map((head, idx) => {
                return (
                  <>
                    {idx === 0 ? (
                      <div
                        style={{
                          width: head?.width,
                        }}
                        className="flex items-center gap-3 px-3 py-3 "
                      >
                        <span>
                          <Checkbox
                            checked={allSelected}
                            onChange={(e) =>
                              handleAllSelected(e.target.checked)
                            }
                          />
                        </span>
                        <span
                          key={head?.title}
                          className=" font-[500] whitespace-nowrap text-[12px] text-fg-muted "
                        >
                          {head?.title}
                        </span>
                      </div>
                    ) : (
                      <div
                        style={{
                          width: head?.width,
                        }}
                        key={head?.title}
                        className="px-3 py-3 whitespace-nowrap font-[500] text-[12px] text-fg-muted "
                      >
                        {head?.title}
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>

          <div className="before:block before:content before:pt-1 overflow-auto  w-[100%] ">
            {loading ? (
              <>
                {[...Array(20)].map((_, index) => {
                  return (
                    <div key={index} className="my-5 bg-surface ">
                      <div colSpan={7}>
                        <ShimmerLoader className="h-8 mb-[1rem]" />
                      </div>
                    </div>
                  );
                })}
              </>
            ) : apiError ? (
              <div>
                <div
                  colSpan={7}
                  className="shadow-sm text-danger h-[30px] font-bold text-2xl p-8 text-center"
                >
                  Something Went Wrong
                </div>
              </div>
            ) : data?.length > 0 ? (
              <InfiniteScroll
                dataLength={data?.length}
                next={() => {
                  dispatch(updatePageNo());
                }}
                hasMore={infinateScroll}
                height={"70vh"}
                endMessage={<></>}
                loader={
                  <div className="w-full flex justify-center  py-3">
                    <CircularProgress size={25} />
                  </div>
                }
              >
                {data?.map((reportData, index) =>
                  RenderTableRow(
                    reportData,
                    index,
                    handleSpecificRowCheckBox,
                    handleEditBooking,
                    {
                      isLastRow: index === data?.length - 1,
                    },
                    activeTab
                  )
                )}
              </InfiniteScroll>
            ) : (
              <div className="w-[100%] flex justify-center items-center p-4 text-success text-[16px]">
                {activeTab == 0
                  ? "There are currently no pending checkouts to display."
                  : activeTab == 1
                  ? "There are currently no pending check-ins to display."
                  : "No outstanding invoices to settle."}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

const SummarySection = ({ data, hotelDetails, summaryRef }) => {
  let posData = data?.posSalesDetails?.map((Obj) => {
    return {
      title: Obj?.posName,
      value: Obj?.totalAmount,
    };
  });

  posData = posData ?? [];

  const totalTax = data?.customTaxDetails?.reduce(
    (acc, currTax) => acc + (currTax?.["taxAmount"] ?? 0),
    0
  );

  posData = [
    { title: "Room Bill", value: data?.frontOffice?.totalFrontOffice },
    ...posData,
    { title: "Total Tax", value: totalTax },
  ];

  const { symbol, position } = getCurrentCurrency(hotelDetails?.currency);

  return (
    <div className="p-3 px-5 flex flex-col gap-[34px]" ref={summaryRef}>
      <header className="flex flex-col justify-start gap-[7px] text-fg text-[18px] font-[400]">
        <span>
          Please Note : After night audit, data for this date will be frozen
        </span>

        {/* <span>Your Closing Day - [ DATE ]</span> */}
      </header>
      <div className="flex flex-col gap-[14px]">
        <span className="font-[500] text-fg text-[19px] ">
          {" "}
          <span> Total Revenue - </span>
          <span className="text-neutral-900 text-[21px] font-[600] leading-[18px]">
            {position === "before" ? symbol : ""}

            {data?.totalRevenue ? data?.totalRevenue?.toFixed(2) : 0}

            {position === "after" ? ` ${symbol}` : ""}
          </span>
        </span>

        <div className="w-[100%] flex gap-[20px] items-center flex-wrap">
          {posData?.map((Obj) => {
            return (
              <BookingTab
                bg={"rgb(var(--color-surface-page))"}
                width={"170px"}
                key={Obj?.title}
                height={"76px"}
                borderColor={"rgb(var(--color-neutral-200))"}
                title={Obj?.title}
                value={Obj?.value}
                hotelDetails={hotelDetails}
              />
            );
          })}
        </div>

        <div></div>
      </div>{" "}
      <div className="flex flex-col gap-[14px]">
        <span className="font-[500] text-fg text-[19px] ">
          {" "}
          Total Payment Received
        </span>

        <div className="flex gap-[20px] items-center flex-wrap">
          {data &&
            data?.paymentByTypes &&
            Object?.keys(data?.paymentByTypes)?.map((Obj) => {
              return (
                <BookingTab
                  bg={"rgb(var(--color-surface-page))"}
                  width={"170px"}
                  height={"76px"}
                  borderColor={"rgb(var(--color-neutral-200))"}
                  key={Obj}
                  title={Obj}
                  value={data?.paymentByTypes?.[Obj]}
                />
              );
            })}
        </div>

        <div></div>
      </div>
    </div>
  );
};

const BookingTab = ({
  title,
  value,
  bg,
  width,
  height,
  borderColor,
  hotelDetails,
}) => {
  const { symbol, position } = getCurrentCurrency(hotelDetails?.currency);

  return (
    <div
      style={{
        backgroundColor: bg,
        width: width,
        height: height,
        border: "1px",
        borderColor: borderColor,
      }}
      className=" flex flex-col gap-[6px] 
      rounded-[10px] justify-start p-3"
    >
      <span className="text-neutral-500 uppercase text-[12px] font-[500] leading-[18px]">
        {title}
      </span>

      <span className="text-neutral-900 text-[21px] font-[700] leading-[18px]">
        {position === "before" ? symbol : ""}

        {value ? value?.toFixed(2) : 0}

        {position === "after" ? ` ${symbol}` : ""}
      </span>
    </div>
  );
};

const RenderTableRow = (
  reportData,
  idx,
  handleSpecificRowCheckBox,
  handleEditBooking,
  { isLastRow },
  activeTab
) => {
  return (
    <div
      className={`bg-surface text-fg font-[400] flex items-center justify-between w-[100%]  
    ${isLastRow ? "" : " border-b-[1px] border-b-brand-border-muted "}`}
      key={idx}
    >
      <div className="flex items-center gap-3 px-3 py-3 w-[20%] ">
        {activeTab === 2 ? (
          <>
            <span>
              <Checkbox
                checked={reportData?.isSelected}
                onChange={(e) =>
                  handleSpecificRowCheckBox(e.target.checked, idx)
                }
              />
            </span>
            <span className="flex flex-col justify-center capitalize">
              {reportData?.invoiceNum
                ? reportData?.invoiceNum
                : reportData?.bookingId
                ? reportData?.bookingId
                : "-"}
            </span>
          </>
        ) : (
          <>
            <span>
              <Checkbox
                checked={reportData?.isSelected}
                onChange={(e) =>
                  handleSpecificRowCheckBox(e.target.checked, idx)
                }
              />
            </span>
            <span className="flex flex-col justify-center capitalize">
              <span>{reportData?.bookingId || "-"}</span>
              <span>{reportData?.source || "-"}</span>
            </span>
          </>
        )}
      </div>

      <div className="px-4 py-3 w-[15%] ">
        {reportData?.customerName
          ? reportData?.customerName?.substring(0, 12)
          : reportData?.name
          ? reportData?.name?.substring(0, 12)
          : "-"}
      </div>

      <RoomTab reportData={reportData} />

      <div className="px-4 py-3 w-[10%] capitalize">
        {reportData?.mealPlan
          ? reportData?.mealPlan
          : reportData?.invoiceType
          ? reportData?.invoiceType
          : "-"}
      </div>

      {activeTab === 2 ? (
        <div className="px-4 py-3 w-[10%] ">
          {reportData?.total ? reportData?.total?.toFixed(2) : "-"}
        </div>
      ) : (
        <div className="px-4 py-3 w-[10%] whitespace-nowrap ">
          {reportData?.checkOut
            ? moment(reportData?.checkOut)?.format("DD MMM YYYY")
            : "-"}
        </div>
      )}

      {activeTab === 2 ? (
        <div className="px-4 py-3 w-[10%] ">
          {reportData?.paid ? reportData?.paid?.toFixed(2) : "-"}
        </div>
      ) : (
        <div className="px-4 py-3 capitalize w-[12.5%] ">
          {reportData?.total ? reportData?.total?.toFixed(2) : "-"}
        </div>
      )}

      {activeTab === 2 ? (
        <div className="px-4 py-3 capitalize w-[12.5%] ">
          {reportData?.total
            ? ((reportData?.total ?? 0) - (reportData?.paid ?? 0))?.toFixed(2)
            : "-"}
        </div>
      ) : (
        <div className="px-4 py-3 capitalize w-[12.5%] ">
          {reportData?.paid ? reportData?.paid?.toFixed(2) : "-"}
        </div>
      )}

      {activeTab !== 2 ? (
        <div className="px-4 py-3 w-[0] ">
          <BsThreeDotsVertical
            className="text-[14px] text-fg-placeholder cursor-pointer"
            onClick={() => {
              handleEditBooking(reportData?.id, reportData?.bookingId);
            }}
          />
        </div>
      ) : (
        <div className="px-4 py-3 w-[0] ">
          <BsThreeDotsVertical className="text-[14px] text-fg-inverse cursor-pointer" />
        </div>
      )}
    </div>
  );
};

const RoomTab = ({ reportData }) => {
  let rooms = reportData?.updatedRooms;

  let roomLength = rooms?.length;

  return (
    <div className="px-4 flex py-3 w-[10%] ">
      <span>
        {Array.isArray(rooms) && rooms?.length > 0
          ? rooms?.slice(0, 2)?.join(",")
          : "-"}
      </span>

      {roomLength > 2 && (
        <span className="text-accent whitespace-nowrap">
          {" "}
          &nbsp; +{roomLength - 1}
        </span>
      )}
    </div>
  );
};

export default Body;
